<template>
  <el-form
    :model="form"
    :rules="rules"
    ref="mobile"
    size="small"
    label-position="left"
    label-width="290px"
  >
    <el-dialog
      :class="dialogclass"
      width="75%"
      top="6vh"
      :visible.sync="popup"
    >
      <h3 slot="title">Que souhaitez-vous résilier ?</h3>

      <div v-if="description === 'Free'" class="choice-logo">
        <el-radio v-model="form.type" label="internet" border>
          Je souhaite résilier mon offre Freebox
          <img src="/static/images/logos/free.png" />
        </el-radio>
        <el-radio v-model="form.type" label="mobile" border>
          Je souhaite résilier mon forfait Mobile
          <img src="/static/images/logos/freemobile.png" />
        </el-radio>
      </div>

      <div v-else>
        <el-radio v-model="form.services" label="Téléphonie mobile" border>
          Forfait mobile
        </el-radio>
        <el-radio v-model="form.services" label="Téléphonie fixe" border>
          Téléphonie fixe
        </el-radio>
        <el-radio v-model="form.services" label="Internet" border>
          Offre internet
        </el-radio>
      </div>

      <el-button type="danger" @click.prevent="close()">
        Commencer ma résiliation
      </el-button>
    </el-dialog>

    <div v-if="description.toString().match(/(orange|^sfr|bouygues)/i)" class="choice">
      <el-radio v-model="form.services" label="Téléphonie mobile" border>
        Je souhaite résilier mon forfait mobile
      </el-radio>
      <el-radio v-model="form.services" label="Téléphonie fixe" border>
        Je souhaite résilier mon téléphone fixe
      </el-radio>
      <el-radio v-model="form.services" label="Internet" border>
        Je souhaite résilier mon offre internet
      </el-radio>
    </div>

    <template v-else>
      <div v-if="internet" class="choice">
        <template v-if="defaultType === 'mobile'">
          <el-radio v-model="form.type" label="mobile" border>Je souhaite résilier mon forfait Mobile</el-radio>
          <el-radio v-model="form.type" label="internet" border>Je souhaite résilier mon offre Internet</el-radio>
        </template>
        <template v-else>
          <el-radio v-model="form.type" label="internet" border>Je souhaite résilier mon offre Internet</el-radio>
          <el-radio v-model="form.type" label="mobile" border>Je souhaite résilier mon forfait Mobile</el-radio>
        </template>
      </div>
    </template>

    <p class="fields-title" style="border-bottom: 1px solid #f1f1f1;padding-bottom:10px">Vous devez saisir les informations ci-dessous pour résilier votre forfait :</p>

    <div style="display:block">
      <el-form-item ref="phone" label="Votre numéro de ligne" prop="phone" required>
        <span slot="label" class="phone-logo">
          Votre numéro de ligne <img :src="logo"  :class="classname" />
        </span>
        <el-input v-model="form.phone" :placeholder="placeholder" />
      </el-form-item>
    </div>

    <div>
      <el-form-item prop="contract" :required="false">
        <span slot="label" class="label-logo">
          Numéro de contrat (facultatif)
        </span>
        <el-input v-model="form.contract" />
        <span class="notice">
          <i class="el-icon-info" /> {{ title }}
        </span>
      </el-form-item>
    </div>

    <p class="fields-title" style="margin-top: 20px;">À partir de quand souhaitez-vous que la résiliation soit effective ?</p>
    <div class="effective-date-section">
      <el-radio-group v-model="form.effectiveDateType" @change="handleEffectiveDateTypeChange" class="effective-date-radio-group">
        <el-radio label="custom" border>Choisir une date</el-radio>
        <el-radio label="immediate" border>Immédiatement</el-radio>
      </el-radio-group>
      <el-date-picker
        v-if="form.effectiveDateType === 'custom'"
        v-model="form.effectiveDate"
        type="date"
        placeholder="Sélectionner une date"
        format="dd/MM/yyyy"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
        class="effective-date-picker"
      />
    </div>

    <div class="valider">
      <el-button
        round
        icon="el-icon-caret-right"
        type="danger"
        :loading="loading"
        @click.prevent="valide"
      >
        Lancer ma résiliation — 39,90 €
      </el-button>

      <p class="secure-notice">Paiement sécurisé par Stripe — Traitement immédiat</p>

      <div class="retractation-notice">
        <p>
          Le client reconnaît que le traitement d'un dossier de résiliation constitue, du fait du choix opéré par le client sur l'identité de la personne concernée renseigné, la fourniture d'un bien personnalisé au sens de l'article L121-21-8, 3° du Code de la consommation. Dès lors, le client est expressément informé qu'il ne peut pas, en application de ces dispositions, exercer son droit de rétractation sur l'achat d'un service sur resiliation-enligne.fr
        </p>
      </div>

      <img src="../../assets/images/secure-payment.png" />
    </div>
  </el-form>
</template>

<script>
export default {
  props: {
    phone: String,
    contract: String,
    loading: Boolean,
    contact: String,
    type: String,
    description: String,
    reference: String,
    title: String,
    internet: {
      type: Boolean,
      default: true
    },
    services: String,
    effectiveDate: String
  },
  data () {
    let popup = false
    if (this.description === 'Free' || this.description.toString().match(/(orange|^sfr|bouygues)/i)) {
      popup = true
    }
    return {
      popup,
      defaultType: this.type,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      form: {
        phone: this.phone,
        contract: this.contract,
        type: this.type,
        services: this.services,
        effectiveDateType: 'immediate',
        effectiveDate: null
      },
      rules: {
        phone: [
          { required: true, message: 'Sélectionnez un numéro de ligne' }
        ],
        contract: [
          { required: false, message: 'Saisissez votre ' + this.reference, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    placeholder () {
      return this.form.type === 'mobile' ? '06 XX XX XX XX' : '01 XX XX XX XX'
    },
    logo () {
      return '/static/images/logos/' + this.classname + '.png'
    },
    dialogclass () {
      return 'pre-select ' + this.classname + '-select'
    },
    classname () {
      return this.description.replace(/\s+/g, '').toLowerCase()
    }
  },
  methods: {
    valide () {
      this.$refs.mobile.validate((valid) => {
        if (valid) {
          this.$emit('valide', this.form)
        }
      })
    },
    close () {
      this.popup = false
      this.$refs.phone.onFieldBlur()
    },
    handleEffectiveDateTypeChange (value) {
      if (value === 'immediate') {
        this.form.effectiveDate = null
      }
    }
  },
  watch: {
    phone (value) {
      this.form.phone = value
    },
    contract (value) {
      this.form.contract = value
    },
    type (value) {
      this.form.type = value
    },
    services (value) {
      this.form.services = value
    },
    form: {
      handler (value) {
        if (value) {
          if (!value.services) {
            value.services = value.type === 'mobile' ? 'Téléphonie mobile' : 'Internet'
          }
          this.$emit('update:type', value.type)
          this.$emit('update:phone', value.phone)
          this.$emit('update:contract', value.contract)
          this.$emit('update:services', value.services)
          this.$emit('update:effectiveDate', value.effectiveDate)
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .retractation-notice {
    max-width: 600px;
    margin: 30px auto 20px;
    text-align: left;
    
    p {
      font-size: 11px;
      color: #666;
      line-height: 1.5;
    }
  }
  .secure-notice {
    font-size: 13px;
    color: #64748b;
    margin: 12px 0 0;
    font-weight: 400;
  }
  .valider {
    img {
      max-width: 250px;
      margin-top: 25px;
    }
  }
  .notice {
    color: #444;
    font-size: 10px;
  }
  .el-select {
    width: 100%;
  }
  
  .effective-date-section {
    max-width: 600px;
    margin: 0 0 20px;
    
    .el-form-item__label {
      float: none !important;
      display: block !important;
      text-align: left !important;
      width: auto !important;
    }
    
    .el-form-item__content {
      margin-left: 0 !important;
    }
    
    .effective-date-radio-group {
      display: flex;
      gap: 10px;
      width: 100%;
      
      .el-radio.is-bordered {
        flex: 1;
        margin: 0 !important;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 12px 20px;
      }
    }
    
    .effective-date-picker {
      width: 100%;
      margin-top: 15px;
    }
  }
  
  @media (max-width: 767px) {
    .effective-date-section {
      .effective-date-radio-group {
        flex-direction: column;
        gap: 5px;
        
        .el-radio.is-bordered {
          width: 100%;
        }
      }
    }
    
    .choice {
      padding: 0;

      .el-radio {
        width: 100%;
        margin: 0 0 5px 0 !important;
      }

      .el-checkbox.is-bordered {
        width: 100%;
        margin: 10px 0 0 0 !important;
      }
    }
  }
</style>

<style lang="scss">
  .effective-date-section {
    .el-form-item__label {
      float: none !important;
      display: block !important;
      text-align: left !important;
      width: auto !important;
    }
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }

  .el-form-item.cgu {
    max-width: 600px;
    margin: 0 auto 15px !important;

    .el-form-item__content {
      padding-top: 10px;
      margin-left: 0 !important;
      text-align: center;
    }
    .el-checkbox__label {
      font-weight: bold;
      font-size: 16px;
    }
    .el-form-item__error {
      text-align: center !important;
      width: 100%;
    }
  }
  .pre-select {
    .el-dialog__header {
      background-size: 125px;
      background-position: top center;
      background-repeat: no-repeat;
      padding-top: 50px;
    }
    .el-button {
      margin-top: 40px;
    }
    &.free-select {
      .el-dialog__header {
        background-image: url(/static/images/logos/free.png);
      }
    }
    &.orange-select {
      .el-dialog__header {
        background-image: url(/static/images/logos/orange.png);
        background-position: top -31px center;
        background-size: 160px;
      }
    }
    &.sfr-select {
      .el-dialog__header {
        background-image: url(/static/images/logos/sfr.png);
        background-position: top -2px center;
        background-size: 100px;
      }
    }
    &.bouyguestelecom-select {
      .el-dialog__header {
        background-image: url(/static/images/logos/bouyguestelecom.png);
        background-position: top -2px center;
        background-size: 160px;
      }
    }
  }
  .choice-logo {
    position: relative;

    .el-radio {
      padding-bottom: 55px;
    }
    img {
      max-height: 24px;
      display: block;
      margin: 8px auto 0;
    }
  }
  .label-logo, .phone-logo {
    position: relative;

    img {
      max-height: 24px;
      position: absolute;
      left: 110px;
      top: -3px;

      &.orange {
        max-height: 64px;
        left: 90px;
        top: -23px;
      }
      &.sosh {
        max-height: 43px;
        left: 120px;
        top: -13px;
      }
      &.sfr {
        max-height: 32px;
        left: 100px;
        top: -7px;
      }
      &.lapostemobile {
        max-height: 64px;
        left: 110px;
        top: -25px;
      }
      &.nrjmobile {
        max-height: 40px;
        left: 110px;
        top: -12px;
      }
      &.auchantelecom {
        max-height: 40px;
        left: 110px;
        top: -12px;
      }
      &.m6mobile {
        max-height: 40px;
        left: 110px;
        top: -12px;
      }
      &.virginmobile {
        max-height: 64px;
        left: 110px;
        top: -25px;
      }
      &.transatel {
        max-height: 64px;
        left: 100px;
        top: -25px;
      }
      &.alicemobile {
        max-height: 64px;
        left: 100px;
        top: -25px;
      }
      &.breizhmobile {
        max-height: 40px;
        left: 110px;
        top: -12px;
      }
      &.cdiscountmobile {
        max-height: 64px;
        left: 110px;
        top: -25px;
      }
      &.lebaramobile {
        max-height: 40px;
        left: 110px;
        top: -12px;
      }
      &.leclercmobile {
        max-height: 40px;
        left: 110px;
        top: -12px;
      }
      &.nordnet {
        max-height: 15px;
        left: 120px;
        top: 0px;
      }
      &.ovhtelecom {
        max-height: 64px;
        left: 110px;
        top: -25px;
      }
      &.ozone {
        max-height: 64px;
        left: 110px;
        top: -25px;
      }
    }

    &.phone-logo {
      img {
        padding-left: 40px;
        background: transparent;
      }
    }
  }

  @media (max-width: 767px) {
    .el-card__body .el-dialog {
      width: 100% !important;

      .el-dialog__body {
        padding-top: 0 !important;

        .choice-logo .el-radio {
          width: 100%;
          margin: 0 0 5px 0 !important;
        }

        .el-checkbox.is-bordered {
          width: 100%;
          margin: 10px 0 0 0 !important;
        }
      }
    }

    .pre-select .el-button {
      margin-top: 10px !important;
    }

    .el-form-item__content {
      margin-left: 0 !important;
    }
    .el-form-item.cgu {
      .el-checkbox__label {
        font-weight: bold;
        font-size: 11px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/mobile.vue